// extracted by mini-css-extract-plugin
export default {"actionContainer":"ManageLicenseModal_actionContainer__CNGhm","actionLabel":"ManageLicenseModal_actionLabel__WbdYo","warning":"ManageLicenseModal_warning__khoXq"};